import { render, staticRenderFns } from "./RecipeListingsSection.vue?vue&type=template&id=6d6174f4&scoped=true&"
import script from "./RecipeListingsSection.vue?vue&type=script&lang=js&"
export * from "./RecipeListingsSection.vue?vue&type=script&lang=js&"
import style0 from "./RecipeListingsSection.vue?vue&type=style&index=0&id=6d6174f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6174f4",
  null
  
)

export default component.exports